export const severityColors = {
  "1": {
    light: "var(--green-3)",
    medium: "var(--green-6)",
    dark: "var(--green-11)",
  },
  "2": {
    light: "var(--purple-3)",
    medium: "var(--purple-6)",
    dark: "var(--purple-11)",
  },
  "3": {
    light: "var(--yellow-3)",
    medium: "var(--yellow-6)",
    dark: "var(--yellow-11)",
  },
  "4": {
    light: "var(--orange-3)",
    medium: "var(--orange-6)",
    dark: "var(--orange-11)",
  },
  "5": {
    light: "var(--crimson-3)",
    medium: "var(--crimson-6)",
    dark: "var(--crimson-11)",
  },
};

export const labStatusColors = new Map([
  ["ordered", { c: "yellow.9", bg: "yellow.0" }],
  ["completed", { c: "green.9", bg: "green.0" }],
]);

export const consultationServiceStatusColors = new Map([
  ["active", { c: "green.9", bg: "green.0" }],
  ["inactive", { c: "red.9", bg: "red.0" }],
]);

export const laboratoryServiceStatusColors = new Map([
  ["active", { c: "green.9", bg: "green.0" }],
  ["inactive", { c: "red.9", bg: "red.0" }],
]);
